import React from 'react'
import PropTypes from 'prop-types'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import EmptyTable from '../../../../components/EmptyTable/EmptyTable'
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material'
import { EnhancedTableHead } from './TableHead'
import { TabConatainer } from '../../styled'
import EditIcon from '../../../../assets/icons/settingsCorner/editIcom'
import DissociationIcon from '../../../../assets/icons/settingsCorner/dissociationIcon'

import moment from 'moment'

import ArchiveeFormation from '../../../../assets/icons/settingsCorner/archiveeFormation'
import {
  FormationFamilyObject,
  keyCategoryObject,
  ParticipantRoleObject,
  ParticipantTypeObject,
  VehicleTypeObject,
} from '../../../../utils/values'

import VisibilityIcon from '@mui/icons-material/Visibility'

import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled'

import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { etatColor } from '../Card/data'
import { StyledTypographyInfoDetail } from '../Card/style'
import ClearIcon from '@mui/icons-material/Clear'

import { useHistory } from 'react-router-dom'

const TableContainer = ({
  actionButton,

  tableHead,
  tableRows,
  isKey,
  isDriverKey,
  isChannel,

  loadingData,

  titleOnglet,
  globalID,
  fetchFiles,
  fetchDataById,

  setOpen,
  setOpenDialogPhoto,
  setOpenArchiveFormation,
  setRow,
  setIsEdit,
  setOpenAnnulation,
  setOpenDissociation,
  setOpenDelete,

  isParticipant,
  isFormation,
  isDriver,
  isVehicle,
  isTournee,
  isUser,
  isSession,
}) => {
  const navigate = useHistory()

  return (
    <TabConatainer component={'div'}>
      <Table
        sx={{ backgroundColor: 'white' }}
        stickyHeader
        aria-label="sticky table"
        aria-labelledby="tableTitle"
        size={'medium'}
      >
        <EnhancedTableHead
          tableHead={tableHead}
          setOpen={setOpen}
          globalID={globalID}
          //dropMenuCreate
          importationParticipant={isParticipant}
        />

        {loadingData ? (
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={tableHead.length + 1}
                sx={{ padding: '8px', border: 'none' }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress sx={{ color: '#1976D2' }} />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : tableRows?.length > 0 ? (
          <TableBody
            sx={{
              '& tr': {
                '& th:first-of-type': {
                  borderLeft: '1px solid #EBEDF0',
                },
              },
              '& tr:nth-of-type(2)': {
                '& th': {
                  borderTop: '1px solid #EBEDF0',
                },

                '& th:first-of-type': {
                  borderTopLeftRadius: '4px',
                },
              },
              '& tr:last-child': {
                '& th:first-of-type': {
                  borderBottomLeftRadius: '4px',
                },
              },
            }}
          >
            <TableRow>
              <TableCell
                colSpan={tableHead.length + 1}
                sx={{ padding: '8px', border: 'none' }}
              >
                <span></span>
              </TableCell>
            </TableRow>
            {tableRows.map((row, rowIndex) => {
              const labelId = `enhanced-table-checkbox-${rowIndex}`

              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={row.id}
                  onClick={
                    isSession
                      ? (event) => {
                          navigate.push(`${titleOnglet}/${row.id}`)
                          event.stopPropagation()
                        }
                      : undefined
                  }
                  sx={{
                    cursor: isSession ? 'pointer' : 'default',
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                >
                  {tableHead.map((col, index) => (
                    <TableCell
                      key={index}
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="normale"
                      sx={
                        col.id == 'competences'
                          ? {
                              color: '#6D7B8E',
                              maxWidth: '50px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }
                          : {
                              color: '#6D7B8E',
                            }
                      }
                    >
                      {col.label?.includes('Date') ? (
                        moment(new Date(row[col.id])).format('YYYY-MM-DD')
                      ) : col.id == 'competences' && Array.isArray(row[col.id]) ? (
                        row[col.id]?.length > 0 ? (
                          <Tooltip
                            arrow
                            title={
                              <span className="tootltip-content">
                                {row[col.id].map((el) => el.value).join(', ')}
                              </span>
                            }
                          >
                            <span>
                              {row[col.id] &&
                                row[col.id].map((el) => el.value).join(', ')}
                            </span>
                          </Tooltip>
                        ) : (
                          '-'
                        )
                      ) : col.id == 'files' ? (
                        <Tooltip
                          title={
                            <span className="tootltip-content">
                              Afficher fichiers
                            </span>
                          }
                          arrow
                        >
                          <IconButton
                            id={`afficher-fichier-${globalID}`}
                            onClick={() => {
                              fetchFiles(row.id)
                              setOpenDialogPhoto(true)
                            }}
                            color="primary"
                            size="small"
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      ) : Array.isArray(row[col.id]) ? (
                        row[col.id][0].value
                      ) : col.id === 'family' ? (
                        FormationFamilyObject[row[col.id]] || '-'
                      ) : col.id === 'type' && (isParticipant || isUser) ? (
                        ParticipantTypeObject[row[col.id]] || '-'
                      ) : col.id === 'type' && isVehicle ? (
                        VehicleTypeObject[row[col.id]] || '-'
                      ) : col.id === 'role' && isDriver ? (
                        ParticipantRoleObject[row[col.id]] || '-'
                      ) : col.id === 'adresse' ||
                        col.id === 'departureAddress' ||
                        col.id === 'arrivalAddress' ? (
                        row[col.id]?.address || '-'
                      ) : col.id === 'fullName' ? (
                        `${row.firstName} ${row.name}`
                      ) : col.id === 'timeWindow' ? (
                        `${row[col.id].start} - ${row[col.id].end}`
                      ) : col.id === 'vehicle' ? (
                        row[col.id]?.immatriculation && row[col.id]?.type ? (
                          `${row[col.id]?.immatriculation} - ${
                            VehicleTypeObject[row[col.id]?.type]
                          }`
                        ) : row[col.id]?.immatriculation ? (
                          `${row[col.id].immatriculation}`
                        ) : row[col.id]?.type ? (
                          ` ${VehicleTypeObject[row[col.id]?.type]}`
                        ) : (
                          '-'
                        )
                      ) : col.id === 'participant' ? (
                        row[col.id]?.firstName && row[col.id]?.lastName ? (
                          `${row[col.id]?.firstName} ${row[col.id]?.lastName}`
                        ) : row[col.id]?.firstName ? (
                          `${row[col.id]?.firstName}`
                        ) : row[col.id]?.lastName ? (
                          ` ${row[col.id]?.lastName}`
                        ) : (
                          '-'
                        )
                      ) : col.id === 'category' ? (
                        ` ${keyCategoryObject[row[col.id]]}`
                      ) : col.id === 'startDate' || col.id === 'endDate' ? (
                        moment(new Date(row[col.id])).format('YYYY-MM-DD')
                      ) : col.id === 'state' ? (
                        <StyledTypographyInfoDetail
                          backgroundColor={
                            row[col.id] &&
                            etatColor.find((e) => e.etat === row[col.id])
                              .backgroundColor
                          }
                          color={
                            row[col.id] &&
                            etatColor.find((e) => e.etat === row[col.id]).color
                          }
                          isEtat={row[col.id]}
                          component="div"
                        >
                          {etatColor.find((e) => e.etat === row[col.id])?.label}
                        </StyledTypographyInfoDetail>
                      ) : (
                        row[col.id] || '-'
                      )}
                    </TableCell>
                  ))}
                  {actionButton ? (
                    <TableCell
                      align="right"
                      sx={{
                        borderRight: '1px solid #EBEDF0',

                        ...(rowIndex === 0 && {
                          borderTopRightRadius: '4px',
                          borderTop: '1px solid #EBEDF0',
                        }),
                        ...(rowIndex === tableRows?.length - 1 && {
                          borderBottomRightRadius: '4px',
                        }),
                      }}
                    >
                      {isFormation ? (
                        <Box sx={{ display: 'flex', placeContent: 'flex-end' }}>
                          <Tooltip
                            title={
                              <span className="tootltip-content">Archiver</span>
                            }
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                setOpenArchiveFormation(true)
                                setRow(row)
                              }}
                              color="primary"
                              size="small"
                              sx={{
                                color: '#B70707',
                                marginRight: '12px',
                              }}
                            >
                              <ArchiveeFormation />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={
                              <span className="tootltip-content">Modifier</span>
                            }
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                setIsEdit(true)
                                setOpen(true)
                                setRow(row)
                                fetchDataById(row.id)
                              }}
                              color="primary"
                              size="small"
                              sx={{ color: '#1876D2' }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : isParticipant ? (
                        <Tooltip
                          title={
                            <span className="tootltip-content">
                              Annuler la participation
                            </span>
                          }
                          arrow
                        >
                          <IconButton
                            onClick={() => {
                              setOpenAnnulation(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                            sx={{
                              color: '#B70707',
                              marginRight: '12px',
                            }}
                          >
                            <PersonAddDisabledIcon />
                          </IconButton>
                        </Tooltip>
                      ) : isUser ? (
                        <Tooltip
                          title={<span className="tootltip-content">Modifier</span>}
                          arrow
                        >
                          <IconButton
                            id={`Modifier-${globalID}`}
                            onClick={() => {
                              setIsEdit(true)
                              setOpen(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                            sx={{ color: '#1876D2' }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      ) : isKey ? (
                        <Tooltip
                          title={<span className="tootltip-content">Modifier</span>}
                          arrow
                        >
                          <IconButton
                            id={`Modifier-${globalID}`}
                            onClick={() => {
                              setIsEdit(true)
                              setOpen(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                          >
                            <EditIcon style={{ color: 'color: #1876D2' }} />
                          </IconButton>
                        </Tooltip>
                      ) : isChannel || isDriverKey ? (
                        <Tooltip
                          title={
                            <span className="tootltip-content">
                              dissocier une clé
                            </span>
                          }
                          arrow
                        >
                          <IconButton
                            id={`dissocier-${globalID}`}
                            onClick={() => {
                              setOpenDissociation(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                          >
                            <DissociationIcon style={{ color: '#B70707' }} />
                          </IconButton>
                        </Tooltip>
                      ) : isDriver ? (
                        <Tooltip
                          title={<span className="tootltip-content">Modifier</span>}
                          arrow
                        >
                          <IconButton
                            id={`Modifier-${globalID}`}
                            onClick={() => {
                              setIsEdit(true)
                              setOpen(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                          >
                            <EditIcon style={{ color: 'color: #1876D2' }} />
                          </IconButton>
                        </Tooltip>
                      ) : isVehicle ? (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Tooltip
                            title={
                              <span className="tootltip-content">Suppression</span>
                            }
                            arrow
                          >
                            <IconButton
                              onClick={() => {
                                setOpenDelete(true)
                                setRow(row)
                              }}
                              color="primary"
                              size="small"
                              sx={{
                                color: '#B70707',
                                marginRight: '12px',
                              }}
                            >
                              <DeleteForeverIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={
                              <span className="tootltip-content">Modifier</span>
                            }
                            arrow
                          >
                            <IconButton
                              id={`Modifier-${globalID}`}
                              onClick={() => {
                                setIsEdit(true)
                                setOpen(true)
                                setRow(row)
                                fetchDataById(row.id)
                              }}
                              color="primary"
                              size="small"
                            >
                              <EditIcon style={{ color: 'color: #1876D2' }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : isTournee ? (
                        <Tooltip
                          title={<span className="tootltip-content">Modifier</span>}
                          arrow
                        >
                          <IconButton
                            id={`Modifier-${globalID}`}
                            onClick={() => {
                              setIsEdit(true)
                              setOpen(true)
                              setRow(row)
                            }}
                            color="primary"
                            size="small"
                          >
                            <EditIcon style={{ color: 'color: #1876D2' }} />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        isSession && (
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip
                              title={
                                <span className="tootltip-content">Annuler</span>
                              }
                              arrow
                            >
                              <IconButton
                                id={`Annuler-${globalID}`}
                                onClick={(event) => {
                                  setOpenAnnulation(true)
                                  setRow(row)
                                  event.stopPropagation()
                                }}
                                size="small"
                                sx={{
                                  color: 'red',
                                }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={
                                <span className="tootltip-content">Modifier</span>
                              }
                              arrow
                            >
                              <IconButton
                                id={`Modifier-${globalID}`}
                                onClick={(event) => {
                                  setIsEdit(true)
                                  setOpen(true)
                                  setRow(row)
                                  event.stopPropagation()
                                }}
                                color="primary"
                                size="small"
                              >
                                <EditIcon style={{ color: 'color: #1876D2' }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={
                                <span className="tootltip-content">Suppression</span>
                              }
                              arrow
                            >
                              <IconButton
                                onClick={(event) => {
                                  setOpenDelete(true)
                                  setRow(row)
                                  event.stopPropagation()
                                }}
                                color="primary"
                                size="small"
                                sx={{
                                  color: '#B70707',
                                  marginRight: '12px',
                                }}
                              >
                                <DeleteForeverIcon />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )
                      )}
                    </TableCell>
                  ) : (
                    <TableCell align="center"></TableCell>
                  )}
                </TableRow>
              )
            })}
          </TableBody>
        ) : (
          <EmptyTable colspan={tableHead.length + 1} />
        )}
      </Table>
    </TabConatainer>
  )
}

TableContainer.propTypes = {
  tableHead: PropTypes.array,
  actionButton: PropTypes.bool,
  tableRows: PropTypes.array,

  loadingData: PropTypes.bool,

  globalID: PropTypes.string,
  titleOnglet: PropTypes.string,
  fetchFiles: PropTypes.func,
  fetchDataById: PropTypes.func,

  setOpen: PropTypes.func,
  setOpenDialogPhoto: PropTypes.func,
  setOpenArchiveFormation: PropTypes.func,
  setRow: PropTypes.func,
  setIsEdit: PropTypes.func,
  setOpenAnnulation: PropTypes.func,
  setOpenDissociation: PropTypes.func,
  setOpenDelete: PropTypes.func,

  isDriver: PropTypes.bool,
  isVehicle: PropTypes.bool,
  isTournee: PropTypes.bool,
  isUser: PropTypes.bool,
  isSession: PropTypes.bool,
  isParticipant: PropTypes.bool,
  isFormation: PropTypes.bool,
  isKey: PropTypes.bool,
  isDriverKey: PropTypes.bool,
  isChannel: PropTypes.bool,
}

export default TableContainer
